import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material';

export default function M8Icon(props: SvgIconProps): JSX.Element {
  const defaultColor = useTheme().palette.primary.dark;
  const color = props.htmlColor || defaultColor;
  return (
    <SvgIcon
      {...props}
      htmlColor={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      enableBackground="new 0 0 30 30"
      titleAccess="M8">
      <path
        d="M3.8 5.6h22.3c1.7 0 3 1.3 3 3v13.8c0 1.7-1.3 3-3 3H3.8c-1.7 0-3-1.3-3-3V8.6c0-1.7 1.4-3 3-3z"
        fill="#0a4842"
      />
      <path
        d="M3.8 5.6h22.3c1.7 0 3 1.3 3 3v13.8c0 1.7-1.3 3-3 3H3.8c-1.7 0-3-1.3-3-3V8.6c0-1.7 1.4-3 3-3z"
        fill="none"
        stroke="#f2b460"
        strokeWidth={1.5}
      />
      <path
        d="M8.8 19.6c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-6.2c0-.2.1-.3.2-.4.1-.1.2-.2.4-.2h.6c.2 0 .3 0 .5.1.1.1.2.2.3.4l1.5 3.8 1.6-3.8c.1-.2.2-.3.3-.4.1-.1.3-.1.5-.1h.6c.2 0 .3.1.4.2.1.1.2.2.2.4V19c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2h-.5c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-3.9l-1 2.3c-.1.2-.2.3-.3.4-.1.1-.3.1-.5.1h-.3c-.2 0-.3 0-.5-.1-.1-.1-.2-.2-.3-.4l-1-2.3V19c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2h-.3zM19 16.4c-.4.2-.6.3-.8.5-.1.2-.2.4-.2.6 0 .3.1.5.4.7.2.2.5.3.9.3s.7-.1.9-.3c.2-.2.4-.4.4-.7 0-.3-.1-.5-.3-.6-.2-.2-.5-.3-1.1-.5H19zm.3-3c-.3 0-.6.1-.8.2-.2.2-.3.4-.3.6 0 .2.1.4.2.5.2.2.4.3.8.4h.2c.6-.2.9-.6.9-1 0-.2-.1-.4-.3-.6-.1 0-.4-.1-.7-.1zm2.1 5.7c-.5.4-1.2.6-2.1.6-.9 0-1.6-.2-2.1-.6-.5-.4-.8-.9-.8-1.5 0-.7.5-1.3 1.4-1.7-.8-.4-1.2-1-1.2-1.8 0-.5.2-1 .7-1.3.5-.4 1.1-.5 2-.5s1.5.2 2 .5.7.8.7 1.3c0 .6-.4 1.2-1.2 1.6 1 .4 1.5 1 1.5 1.9-.1.6-.4 1.1-.9 1.5z"
        fill="#f2b460"
      />
    </SvgIcon>
  );
}
